import Actions from '../../odata/actions';

const actions = new Actions('mfcDefault', 'mfcDefaults');

export default actions;
